import { render, staticRenderFns } from "./TravelServiceItemDetailsView.vue?vue&type=template&id=00b4f41c&scoped=true&"
import script from "./TravelServiceItemDetailsView.vue?vue&type=script&lang=js&"
export * from "./TravelServiceItemDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4f41c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b4f41c')) {
      api.createRecord('00b4f41c', component.options)
    } else {
      api.reload('00b4f41c', component.options)
    }
    module.hot.accept("./TravelServiceItemDetailsView.vue?vue&type=template&id=00b4f41c&scoped=true&", function () {
      api.rerender('00b4f41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/travel-service/TravelServiceItemDetailsView.vue"
export default component.exports